/* eslint-disable default-case */
import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, DetailRow, Filter, Inject, Sort, Page } from '@syncfusion/ej2-react-grids';
import { SampleBase } from './sample-base';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import { random } from 'underscore';
import { toast } from 'react-toastify';
import BlockUi from '@availity/block-ui';

function headerTemplate(props) {
    return (
        <div>
            <span style={{ fontSize: '0.9vw', fontWeight: 'bolder' }}>{props.headerText}</span>
        </div>
    );
}

function fieldTemplate(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: '#133B95', fontWeight: 'bold' }}>
                {props[props.column.field]}
            </span>
        </div>
    );
}

function fieldTemplateInt(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {(props[props.column.field] || 0).toLocaleString('it-IT')}
            </span>
        </div>
    );
}

function fieldTemplateDecimal(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {(props[props.column.field] || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
        </div>
    );
}

function fieldTemplateCompagniaKAM(props) {
    if (!props.Compagnia) {
        return (
            <div>
                <div style={{ fontSize: '1.0vw', color: '#B22222', fontWeight: 'bold' }}>
                    {props.KeyAccountManager}
                </div>
            </div>
        );
    }
    return (
        <div>
            <div style={{ fontSize: '1.0vw', color: '#133B95', fontWeight: 'bold' }}>
                {props.Compagnia}
            </div>
            <div style={{ fontSize: '0.85vw', color: '#6E6E6E', fontWeight: '600' }}>
                ({props.KeyAccountManager})
            </div>
        </div>
    );
}

const CHILD_COLUMNS = [
    {
        field: 'Perito',
        headerText: 'Perito',
        headerTemplate: headerTemplate,
        template: fieldTemplate,
        textAlign: 'Center'
    },
    {
        field: 'SinistriTotaliApertiSIC',
        headerText: 'Sinistri Totali Aperti S/I/C',
        headerTemplate: headerTemplate,
        template: fieldTemplateTotaliApertiSIC,
        textAlign: 'Center'
    },
    {
        field: 'SinistriIntermedApertiChiusControllo',
        headerText: 'Sinistri Intermedi Aperti / In Chiusura / In Controllo',
        headerTemplate: headerTemplate,
        template: fieldTemplateIntermedTripla,
        textAlign: 'Center'
    },
    {
        field: 'DiCuiProperty',
        headerText: 'Di Cui Property Aperti / In Chiusura / In Controllo',
        headerTemplate: headerTemplate,
        template: fieldTemplatePropertyTripla,
        textAlign: 'Center'
    },
    {
        field: 'DiCuiRC',
        headerText: 'Di Cui RC Aperti / In Chiusura / In Controllo',
        headerTemplate: headerTemplate,
        template: fieldTemplateRCTripla,
        textAlign: 'Center'
    },
    {
        field: 'SinistriIntermedApertiMeseCorrente',
        headerText: 'Sinistri Intermedi Aperti Mese Corrente',
        headerTemplate: headerTemplate,
        template: fieldTemplateInt,
        textAlign: 'Center'
    },
    {
        field: 'SinistriIntermedChiusiMeseCorrente',
        headerText: 'Sinistri Intermedi Chiusi Mese Corrente',
        headerTemplate: headerTemplate,
        template: fieldTemplateInt,
        textAlign: 'Center'
    },
    {
        field: 'MediaGiorniApertiProperty',
        headerText: 'Media Giorni Aperti Property',
        headerTemplate: headerTemplate,
        template: fieldTemplateDecimal,
        textAlign: 'Center'
    },
    {
        field: 'MediaGiorniApertiRC',
        headerText: 'Media Giorni Aperti RC',
        headerTemplate: headerTemplate,
        template: fieldTemplateDecimal,
        textAlign: 'Center'
    },
    {
        field: 'MediaGiorniRestituitiProperty',
        headerText: 'Media Giorni Restituiti Property',
        headerTemplate: headerTemplate,
        template: fieldTemplateDecimal,
        textAlign: 'Center'
    },
    {
        field: 'MediaGiorniRestituitiRCT',
        headerText: 'Media Giorni Restituiti RCT',
        headerTemplate: headerTemplate,
        template: fieldTemplateDecimal,
        textAlign: 'Center'
    },
    {
        field: 'SinistriIntermedChiusiAnnoCorrente',
        headerText: 'Sinistri Intermedi Chiusi Anno Corrente',
        headerTemplate: headerTemplate,
        template: fieldTemplateInt,
        textAlign: 'Center'
    }
];

const CAMPI_SOMMA = [
    'SinistriTotaliApertiSIC',
    'SinistriTotaliAperti_Semplici',
    'SinistriTotaliAperti_Intermedi',
    'SinistriTotaliAperti_Complessi',
    'SinistriIntermedApertiChiusControllo',
    'SinistriIntermedInChiusura',
    'SinistriIntermedInControllo',
    'DiCuiProperty',
    'DiCuiProperty_InChiusura',
    'DiCuiProperty_InControllo',
    'DiCuiRC',
    'DiCuiRC_InChiusura',
    'DiCuiRC_InControllo',
    'SinistriIntermedApertiMeseCorrente',
    'SinistriIntermedChiusiMeseCorrente',
    'SinistriIntermedChiusiAnnoCorrente'
];
// Costanti dei campi che SONO totali di compagnia (vanno presi da Livello 0, non aggregati)
const CAMPI_TOTALI_COMPAGNIA = [
    'SinistriTotaliApertiSIC',
    'SinistriTotaliAperti_Semplici',
    'SinistriTotaliAperti_Intermedi',
    'SinistriTotaliAperti_Complessi'
];

// Campi che vanno sommati sui periti (Intermedi di quella compagnia)
const CAMPI_SOMMA_DA_PERITI = [
    'SinistriIntermedApertiChiusControllo',
    'SinistriIntermedInChiusura',
    'SinistriIntermedInControllo',
    'DiCuiProperty',
    'DiCuiProperty_InChiusura',
    'DiCuiProperty_InControllo',
    'DiCuiRC',
    'DiCuiRC_InChiusura',
    'DiCuiRC_InControllo',
    'SinistriIntermedApertiMeseCorrente',
    'SinistriIntermedChiusiMeseCorrente',
    'SinistriIntermedChiusiAnnoCorrente'
];
const CAMPI_MEDIA = [
    'MediaGiorniApertiProperty',
    'MediaGiorniApertiRC',
    'MediaGiorniRestituitiProperty',
    'MediaGiorniRestituitiRCT'
];

function fieldTemplateTotaliApertiSIC(props) {
    const tot = props.SinistriTotaliApertiSIC || 0;
    const s = props.SinistriTotaliAperti_Semplici || 0;
    const i = props.SinistriTotaliAperti_Intermedi || 0;
    const c = props.SinistriTotaliAperti_Complessi || 0;
    return (
        <div>
            <div style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {tot.toLocaleString('it-IT')}
            </div>
            <div style={{ fontSize: '0.7vw', color: '#6E6E6E', fontWeight: '600' }}>
                ({`S=${s.toLocaleString('it-IT')}, I=${i.toLocaleString('it-IT')}, C=${c.toLocaleString('it-IT')}`})
            </div>
        </div>
    );
}

function fieldTemplateIntermedTripla(props) {
    const tot = props.SinistriIntermedApertiChiusControllo || 0;
    const ch = props.SinistriIntermedInChiusura || 0;
    const ctrl = props.SinistriIntermedInControllo || 0;
    const aperti = Math.max(0, tot - ch - ctrl);
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {`${aperti.toLocaleString('it-IT')} / ${ch.toLocaleString('it-IT')} / ${ctrl.toLocaleString('it-IT')}`}
            </span>
        </div>
    );
}

function fieldTemplatePropertyTripla(props) {
    const tot = props.DiCuiProperty || 0;
    const ch = props.DiCuiProperty_InChiusura || 0;
    const ctrl = props.DiCuiProperty_InControllo || 0;
    const aperti = Math.max(0, tot - ch - ctrl);
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {`${aperti.toLocaleString('it-IT')} / ${ch.toLocaleString('it-IT')} / ${ctrl.toLocaleString('it-IT')}`}
            </span>
        </div>
    );
}

function fieldTemplateRCTripla(props) {
    const tot = props.DiCuiRC || 0;
    const ch = props.DiCuiRC_InChiusura || 0;
    const ctrl = props.DiCuiRC_InControllo || 0;
    const aperti = Math.max(0, tot - ch - ctrl);
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {`${aperti.toLocaleString('it-IT')} / ${ch.toLocaleString('it-IT')} / ${ctrl.toLocaleString('it-IT')}`}
            </span>
        </div>
    );
}

// Referente corretto = riga con più sinistri aperti (assegnazione attiva corrente)
function rigaReferenteCorretta(rows) {
    return _.max(rows, r => r.SinistriIntermedApertiChiusControllo || 0);
}

function mergeValori(base, rows) {
    const merged = { ...base };
    CAMPI_SOMMA.forEach(campo => {
        merged[campo] = _.reduce(rows, (s, r) => s + (r[campo] || 0), 0);
    });
    CAMPI_MEDIA.forEach(campo => {
        const attivi = rows.filter(r => r[campo] != null && r[campo] !== 0);
        merged[campo] = attivi.length > 0
            ? Math.round(_.reduce(attivi, (s, r) => s + r[campo], 0) / attivi.length * 100) / 100
            : 0;
    });
    return merged;
}

function mergeValoriMaster(base, rows, livello0Row) {
    const merged = { ...base };
    // Totali di compagnia: presi pari pari da Livello 0
    CAMPI_TOTALI_COMPAGNIA.forEach(campo => {
        merged[campo] = livello0Row ? (livello0Row[campo] || 0) : 0;
    });
    // Campi Intermedi: sommati dai periti
    CAMPI_SOMMA_DA_PERITI.forEach(campo => {
        merged[campo] = _.reduce(rows, (s, r) => s + (r[campo] || 0), 0);
    });
    // Medie: invariate
    CAMPI_MEDIA.forEach(campo => {
        const attivi = rows.filter(r => r[campo] != null && r[campo] !== 0);
        merged[campo] = attivi.length > 0
            ? Math.round(_.reduce(attivi, (s, r) => s + r[campo], 0) / attivi.length * 100) / 100
            : 0;
    });
    return merged;
}

function aggregaMasterDaPeriti(peritiDeduplicate, livello0Rows) {
    const livello0ById = _.indexBy(livello0Rows, 'id_compagnia');
    const grouped = _.groupBy(peritiDeduplicate, 'id_compagnia');
    return Object.values(grouped).map(rows => {
        const base = {
            ...rigaReferenteCorretta(rows),
            Livello: 0
        };
        return mergeValoriMaster(base, rows, livello0ById[rows[0].id_compagnia]);
    });
}

// Deduplica periti: un record per (id_compagnia, Perito).
// Se il perito ha più righe (una per ciascun KAM storico della compagnia),
// si prende SOLO quella legata al KAM effettivo/corrente (quello mostrato
// al 1° livello), scartando le assegnazioni storiche con altri KAM.
function deduplicaChild(childData, livello0Rows) {
    const kamEffettivoById = _.object(
        _.pluck(livello0Rows, 'id_compagnia'),
        _.pluck(livello0Rows, 'KeyAccountManager')
    );
    const grouped = _.groupBy(childData, r => `${r.id_compagnia}_${r.Perito}`);
    return Object.values(grouped).map(rows => {
        if (rows.length === 1) return rows[0];
        const kamEffettivo = kamEffettivoById[rows[0].id_compagnia];
        const rigaAttuale = rows.find(r => r.KeyAccountManager === kamEffettivo);
        return rigaAttuale || mergeValori(rigaReferenteCorretta(rows), rows);
    });
}

export default class PaginaSinistriIntermedi extends SampleBase {
    constructor() {
        super(...arguments);
        this.toolbarOptions = ['ExcelExport', 'Search'];
        this.pageSettings = { pageSize: 10 };
        this.toggleBlocking = this.toggleBlocking.bind(this);
    }
    state = {
        blocking: false,
        dataSource: [],
        allPeriti: []
    }
    toggleBlocking() {
        this.setState({ blocking: !this.state.blocking });
    }
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-excelexport':
                this.gridInstance.excelExport({ hierarchyExportMode: 'All' });
                break;
        }
    }
    onDataBoundMaster() {
        const grid = document.getElementById('GridSinistriIntermedi');
        if (!grid) return;
        const headerRow = grid.querySelector('.e-gridheader .e-headercontent table thead tr');
        if (headerRow) {
            for (let ind = 0; ind < headerRow.children.length; ind++) {
                headerRow.children[ind].style.backgroundColor = 'Linen';
            }
        }
        const testoEl = document.getElementById('TestoDatiAggiornati');
        if (testoEl) {
            const now = new Date();
            testoEl.innerText =
                `Dati aggiornati al ${now.getDate().toString().padStart(2, '0')}/` +
                `${(now.getMonth() + 1).toString().padStart(2, '0')}/` +
                `${now.getFullYear()} alle ore ${now.getHours().toString()}:` +
                `${now.getMinutes().toString().padStart(2, '0')}`;
        }
    }
    onDataBoundDetail() {
        document.querySelectorAll('.e-detailrow .e-gridheader thead tr')
            .forEach(headerRow => {
                for (let ind = 0; ind < headerRow.children.length; ind++) {
                    headerRow.children[ind].style.backgroundColor = '#E3F2FD';
                }
            });
    }
    onRowDataBoundMaster(args) {
        if (args.data.Livello === 99) {
            args.row.style.backgroundColor = '#FFCDD2';
            args.row.style.fontWeight = 'bold';
            const expandCell = args.row.querySelector('.e-detailrowcollapse');
            if (expandCell) {
                expandCell.style.visibility = 'hidden';
                expandCell.style.pointerEvents = 'none';
            }
        }
    }
    onDetailDataBound(args) {
        if (args.detailElement) {
            args.detailElement.style.padding = '20px';
        }
    }
    componentDidMount() {
        this.caricaDati();
    }
    getChildGridOptions() {
        return {
            dataSource: this.state.allPeriti,
            queryString: 'id_compagnia',
            gridLines: 'Both',
            allowSelection: false,
            enableHover: false,
            dataBound: this.onDataBoundDetail.bind(this),
            columns: CHILD_COLUMNS
        };
    }
    render() {
        const childGridOptions = this.getChildGridOptions();
        return (
            <React.Fragment>
                <BlockUi tag='div' id='blockUI1' blocking={this.state.blocking} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                <GridComponent
                    id="GridSinistriIntermedi"
                    ref={grid => this.gridInstance = grid}
                    height='65vh'
                    dataSource={this.state.dataSource}
                    toolbar={this.toolbarOptions}
                    allowPaging={false}
                    allowExcelExport={true}
                    hierarchyPrintMode='All'
                    childGrid={childGridOptions}
                    detailDataBound={this.onDetailDataBound.bind(this)}
                    gridLines='Both'
                    allowTextWrap={true}
                    allowSelection={false}
                    enableHover={false}
                    toolbarClick={this.toolbarClick.bind(this)}
                    dataBound={this.onDataBoundMaster.bind(this)}
                    rowDataBound={this.onRowDataBoundMaster.bind(this)}>
                    <ColumnsDirective>
                        <ColumnDirective
                            field='Compagnia'
                            headerText='Key Account Manager'
                            width='15%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateCompagniaKAM}
                            textAlign='Center' />

                        <ColumnDirective
                            field='SinistriTotaliApertiSIC'
                            headerText='Sinistri Totali Aperti S/I/C'
                            width='10%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateTotaliApertiSIC}
                            textAlign='Center' />

                        <ColumnDirective
                            field='SinistriIntermedApertiChiusControllo'
                            headerText='Sinistri Intermedi Aperti / In Chiusura / In Controllo'
                            width='8%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateIntermedTripla}
                            textAlign='Center' />

                        <ColumnDirective
                            field='DiCuiProperty'
                            headerText='Di Cui Property Aperti / In Chiusura / In Controllo'
                            width='8%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplatePropertyTripla}
                            textAlign='Center' />

                        <ColumnDirective
                            field='DiCuiRC'
                            headerText='Di Cui RC Aperti / In Chiusura / In Controllo'
                            width='8%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateRCTripla}
                            textAlign='Center' />

                        <ColumnDirective
                            field='SinistriIntermedApertiMeseCorrente'
                            headerText='Sinistri Intermedi Aperti Mese Corrente'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            textAlign='Center' />

                        <ColumnDirective
                            field='SinistriIntermedChiusiMeseCorrente'
                            headerText='Sinistri Intermedi Chiusi Mese Corrente'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            textAlign='Center' />

                        <ColumnDirective
                            field='MediaGiorniApertiProperty'
                            headerText='Media Giorni Intermedi Aperti Property'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective
                            field='MediaGiorniApertiRC'
                            headerText='Media Giorni Intermedi Aperti RC'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective
                            field='MediaGiorniRestituitiProperty'
                            headerText='Media Giorni Intermedi Restituiti Property'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective
                            field='MediaGiorniRestituitiRCT'
                            headerText='Media Giorni Intermedi Restituiti RCT'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective
                            field='SinistriIntermedChiusiAnnoCorrente'
                            headerText='Sinistri Intermedi Chiusi Anno Corrente'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            textAlign='Center' />
                    </ColumnsDirective>
                    <Inject services={[Toolbar, ExcelExport, DetailRow, Page, Sort, Filter]} />
                </GridComponent>
                </BlockUi>
            </React.Fragment>
        );
    }
    caricaDati() {
        this.toggleBlocking();
        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/sinistriIntermedi/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            const livello0Rows = retData.filter(r => r.Livello === 0);
            const childData = deduplicaChild(retData.filter(r => r.Livello === 1), livello0Rows);
            const totaleRow = retData.find(r => r.Livello === 99);
            const masterBase = aggregaMasterDaPeriti(childData, livello0Rows);
            const masterData = totaleRow ? [totaleRow, ...masterBase] : masterBase;
            this.setState({ dataSource: masterData, allPeriti: childData });           
        },
        error => {
            this.toggleBlocking();
            let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1
                ? CustomJS.messaggioAPIBackendNonTrovata
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            toast.warn("Errore chiamata API");
        }, true, false);
    }
}
